import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.9 12.1" {...props}><path fill="#E35525" d="M20.1 5.7L15.4 1c-.1-.1-.2-.2-.4-.2-.1 0-.3.1-.4.2-.2.2-.2.6 0 .8l3.8 3.8H1.2c-.3-.1-.6.1-.6.4s.2.5.5.5h17.2l-3.8 3.8c-.2.2-.2.6 0 .8.2.2.6.2.8 0L20 6.4c.3-.2.3-.5.1-.7z" /></svg>);


// WEBPACK FOOTER //
// ./public/images/global/icon__arrow.svg